<template>
  <div id="team-detail" class="contribute-team">
    <div class="person team-item">
      <div class="h">
        <div class="img">
          <img :src="data.member.avatar" alt="" />
        </div>
        <div class="text">
          <div class="left">
            <div class="t">
              <span v-if="data.member.type == 1" class="leader">团长</span>
              {{ data.member.realname }}
            </div>
            <div class="p">
              {{ data.member.mobile }}
            </div>
          </div>
          <!-- <div class="right">
            <span @click="goDetail">查看详情</span>
          </div> -->
        </div>
      </div>
      <div class="b">
        <ul class="file-list">
          <li
            @click="goInfo(item)"
            v-for="(item, index) in data.works"
            :key="index"
          >
            <div class="img">
              <img :src="item.image" alt="" />
              <p class="location">
                <span
                  ><i class="ico ico-location"></i
                  >{{ item.shoot_address }}</span
                >
              </p>
            </div>
            <p class="t">{{ item.mname }}</p>
            <p class="m">{{ item.remark }}</p>
          </li>
        </ul>
      </div>
    </div>
    <footer>
      <Tips :curCount="teamInfo.workscount" :member="teamInfo.membercount" :total="matchInfo.team_works_total" />
      <div
        class="bd"
        v-if="
          data.is_control == 1 &&
            data.works.length < matchInfo.team_works_num &&
            teamInfo.workscount < matchInfo.team_works_total
        "
      >
        <a class="btn-w btn-goon" @click="goUpload" href="javascript:;"
          >继续投稿</a
        >
      </div>
    </footer>
  </div>
</template>

<script>
import Tips from "@/components/GroupTips";
export default {
  components: {
    Tips,
  },
  data() {
    return {
      bgImg: [
        require("@/static/images/group/i-1.png"),
        require("@/static/images/group/i-8.png"),
      ],
      demo: require("@/static/images/pic-6.png"),
      id: this.$route.params.id,
      uid: this.$route.query.uid,
      teamInfo: {},
      matchInfo: {
        team_member_num: 0,
        team_works_num: 0,
        team_works_total: 0,
      },
      data: {
        avatar: "",
        name: "",
        mobile: "",
        is_control: 0,
        works: [
          // {
          //   img: require("@/static/images/pic-6.png"),
          //   location: "地理定位位置",
          //   title: "这个作品标题是什么什么",
          //   desc: "作品描述明细，从任何渠道",
          // },
        ],
      },
    };
  },
  methods: {
    goUpload() {
      this.$router.push({
        path: "/contribute/" + this.id + "/team/team",
        query: {
          id: this.$route.query.uid,
          group: this.$route.query.gid,
        },
      });
    },
    goInfo(item) {
      this.$router.push({
        path: "/detail/" + this.id + "/team-info/" + item.id,
        query: {
          myworks: this.data.is_control == 1 ? 1 : "",
          membercount: this.teamInfo.membercount,
          workscount: this.teamInfo.workscount,
          id: this.$route.query.uid,
          gid: this.$route.query.gid,
        },
      });
    },
  },
  created() {
    // 获取数据
    this.axios
      .post(this.tools.api.teamWorksList, { uid: this.uid, mid: this.id })
      .then((res) => {
        // console.log(res);
        this.teamInfo = res.data.data.team;
        this.matchInfo = res.data.data.match;
        let data = res.data;
        if (data.code == 200) {
          this.data = data.data;
          this.data.works = data.data.works;
        }
        // console.log(this.data);
      });
  },
};
</script>

<style lang="scss" scoped>
.contribute-team {
  background: #f5f8fa;
  min-height: 100vh;
  footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    z-index: 1;
    .bd {
      background: #fff;
      height: 106px;
      text-align: center;
      overflow: hidden;
      box-shadow: 0 0 15px rgba(100, 100, 100, 0.1);
      .btn-goon {
        width: 42%;
        font-size: #{"14PX"};
        color: #fff;
        height: 72px;
        line-height: 72px;
        background: #f77e5e;
        margin: 17px auto 0;
      }
    }
  }
  .leader {
    width: 86px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: #{"12PX"};
    border-top-left-radius: 20px;
    border-bottom-right-radius: 20px;
    color: #fff;
    display: inline-block;
    background: linear-gradient(to right, #c5905d, #f5c594);
  }
}
.team-item {
  padding: 0 0 30px 0;
  .h {
    overflow: hidden;
    background: #fff;
    padding: 30px 30px 20px;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
    .img {
      float: left;
      margin-right: 22px;
      width: 64px;
      height: 64px;
      padding: 4px;
      border-radius: 50%;
      background-image: linear-gradient(to right, #ff5026, #ffcdb5);
      img {
        background: #fff;
        width: 100%;
        height: 100%;
        display: block;
        border-radius: 50%;
      }
    }
    .text {
      padding: 2px 0 0;
      .t {
        color: #666;
        font-size: 22px;
        .ico {
          margin-right: 5px;
        }
      }
      .p {
        padding: 8px 0 0;
        font-size: 18px;
      }
    }
    .left {
      color: #666;
      height: 36px;
      line-height: 36px;
      padding: 0 5px;
      display: inline-block;
    }
    .right {
      color: #fff;
      float: right;
      padding-top: 10px;
      span {
        height: 44px;
        line-height: 44px;
        width: 140px;
        border-radius: 8px;
        text-align: center;
        color: #fff;
        background-image: linear-gradient(to right, #f77e5e, #ffa265);
        display: inline-block;
        font-size: 21px;
        margin: 0 5px;
      }
    }
  }
  .b {
    padding-bottom: 170px;
    .file-list {
      padding: 0 20px;
      overflow: hidden;
      .ico {
        display: inline-block;
        vertical-align: top;
      }
      .ico-location {
        background: url("../../static/images/group/location1.png");
        background-size: cover;
        width: 24px;
        height: 30px;
        margin: 12px 8px 0 0;
      }
      li {
        width: 100%;
        margin: 20px 0 0;
        background: #fff;
        border-radius: 8px;
        overflow: hidden;

        .img {
          width: 100%;
          height: 338px;
          background: #fff;
          position: relative;
          overflow: hidden;
          img {
            position: relative;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            max-height: 100%;
            max-width: 100%;
          }
          .location {
            position: absolute;
            bottom: 0;
            width: 100%;
            background: rgba(0, 0, 0, 0.4);
            color: #fff;
            height: 55px;
            line-height: 55px;
            &::before {
              content: "";
              position: absolute;
              width: 100%;
              height: 100%;
              background-image: linear-gradient(
                to bottom,
                #ddd,
                transparent,
                transparent
              );
              opacity: 0.2;
              left: 0;
            }
            span {
              position: relative;
              z-index: 1;
              white-space: nowrap;
              padding: 0 8px 0 24px;
              box-sizing: border-box;
              overflow: hidden;
              display: inline-block;
              width: 100%;
              height: 100%;
              line-height: 55px;
              text-overflow: ellipsis;
            }
          }
        }
        .t {
          font-size: #{"16PX"};
          line-height: 56px;
          font-weight: bold;
          height: 56px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          padding: 5px 14px 0;
        }
        .m {
          font-size: #{"12PX"};
          line-height: 40px;
          padding: 5px 14px 14px;
          // margin-bottom: 14px;
          // max-height: 80px;
          // overflow: hidden;
        }
      }
      li:last-child {
        margin-right: 0;
      }
      .ico-add {
        background-position: 0 -50px;
        width: 50px;
        height: 50px;
        margin-top: 34px;
      }
    }
  }
}
</style>
